import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useStores } from '../../stores/Hooks';
import { ValidationStatusComponent } from '../../components/ValidationStatusComponent';
import { FilesClarifyLinkComponent } from './FilesClarifyLinkComponent';

export const FilesPageRightBlock: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.files;

		function Fill()
		{
			store.SortedFileTypeArray.forEach((val) =>
			{
				let file = new File(["foo"], val.Name + ".pdf", { type: "application/pdf" });
				store.AddFileLibrary(val.Id, file).setPageCount(1);
			});
		}

		const percent = Math.round(store.CurrentStorageSize / store.MaxStorageSize * 100);

		return (
			<div className="form-steps">
				<ValidationStatusComponent />
				<hr />
				<div className="form-step-progress">
					<div className="in-progress">
						<p className="in-progress__header">Объем загруженных файлов </p>
						<div className={"in-progress__progressbar" + (percent >= 50 ? " half" : "")}>
							<div className="in-progress__percents">{store.shortFileSize(store.CurrentStorageSize)}</div>
							<div className="in-progress__progressbar-full"></div>
							<div className="in-progress__progressbar-complete" style={{ width: percent + "%" }}></div>
						</div>
						<p className="f-14 in-progress__info">Допустимы к загрузке – PDF, TIFF</p>
						<p className="f-14 in-progress__info">Максимальный объем — 70 Мб</p>
					</div>
				</div>
				{!uiState.IsDisabled &&
					<div className="form-step-info">
						<div className="mb-0">
							Перечень загруженных документов будет приложен <br /> к заявлению оператора ЭДО.
							{uiState.FillButtons &&
								<button
									className="btn"
									type="button"
									onClick={Fill}
								>Заполнить</button>
							}
						</div>
					</div>
				}
				<FilesClarifyLinkComponent />
			</div>
		);
	}
)
